import React from 'react';
import UsersContainer from './UsersContainer';

const Users = (props) => (
  <UsersContainer {...props} />
);

export default Users;



// WEBPACK FOOTER //
// src/routes/Users/index.js